<template>
<EntityReport entity="ReportHealth" />
</template>

<script>
export default {

}
</script>
